import useSwr from "@/core/composables/swr/useSwr";
import {massCertificationApi} from "@/container";

/**
 * SWR composable to fetch the notification templates placeholders.
 */
const usePlaceHolders = () => {
    return useSwr(
        'mass-certification/notifications/placeholders',
        () => massCertificationApi().placeholders()
    );
};

export default usePlaceHolders;
